import React from 'react';

import './style/CardValue.scss';

const CardValue = (props) => {
	const { side1, side2 } = props;

	return (
		<div className="componentCardValue">
			<div className="side">
				<div className="content-data">
					{ side1 }
				</div>
			</div>

			<div className="side">
				<div className="content-data">
					{ side2 }
				</div>
			</div>
		</div>
	);
};

export default CardValue;
